import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import FilesView from "../../../../Components/Utils/FilesView";
import { NuInput } from "../../../../Components/Utils/Input";
import ScheduleLayout from "./ScheduleLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
import { CalendarDays } from "lucide-react";
import PDFViewer from "../../../../Components/Utils/PDFViewer";

function ViewSheduleTesting(onClose) {
  const { scheduleViewId } = useParams();
 

  const location = useLocation();
  const cdata = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
   const [createNew, setCreateNew] = useState({
    name:""
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const [showPdfComponent, setShowPdfComponent] = useState(false);
  
  const handlePdfIconClick = () => {
    setShowPdfComponent(true);
  };

  const [data,setData] = useState(cdata? cdata:null); 
  
  const[isSubmit,setisSubmited]=useState(false)


  function getView() {
    axiosInstance 
      .get(`/tc-schedules/${scheduleViewId}`)
      .then((res) => {
        setData(res.data?.data); 
                setisSubmited(res.data?.data?.isSubmitted === true);       
      
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cdata) {
      getView();
    // }
  }, [])

  

 const [filePathList, setFilePathList] = useState([]);
 
   useEffect(() => {
     if (
       data?.attachments !== null &&
       data?.attachments !== "None" &&
       data?.attachments !== "[]"
     ) {
       setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
     }
   }, [data]);


const [viewPDF,setViewPDF] = useState(null);
const [pdfLoading,setPdfLoading] = useState(false)

const ViewPDF = async () => {
  setPdfLoading(true)
  try {
      const response = await axiosInstance.get(`/tc-schedules/get-report/${scheduleViewId}`, {
          responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
      setPdfLoading(false)
  } catch (error) {
      console.error('Error downloading the PDF:', error);
      setPdfLoading(false)
  }
};

useEffect(() => {
  ViewPDF()
},[scheduleViewId,data])

const [pdfAvailable, setPdfAvailable] = useState(false);

  const getpdf = () => {
    axiosInstance
      .get(`/tc-schedules/get-report/${scheduleViewId}`)
      .then((res) => {
        if (res.data?.data === true) {
          // setPdfAvailable(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getpdf();
  }, []);



   const id = scheduleViewId; 
  const getUrl = `/tc-schedules/get-status`;
  const putUrl = `/tc-schedules/edit-status`; 
  const statusUrl = '/tc-schedules/all-status';

  
  return (
    <ScheduleLayout 
    EditAccess={GetAccess("commissioning_schedules_edit")}
          // BackAccess={GetAccess("testing_and_commisioning_module")}
    >
    <div className="w-full h-full mt-0.5 overflow-y-auto  ">
      {/* <div className="flex justify-end ">
        <div className=" flex gap-2">
          <Link
            to={`/Contract-management/schedules`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/Contract-management/schedules/edit/${scheduleViewId}`}
            state={{
              data: data,
              from: `/Contract-management/schedules/view/${scheduleViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div> */}

      <div className="w-full mx-auto h-[calc(100vh-175px)]  rounded-md    md:flex gap-2 text-[#111537]">
        <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center ">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[90%]">
                <p className="flex">{data?.refNumber}</p>
              </div>
              <div className="flex gap-4 justify-between">
              <p className="flex items-center gap-2 text-xs text-[#111537]">
                  <CalendarDays size={14} className="text-gray-500 shrink-0" />
                  {data?.date ? (
                    <NuDate value={data?.date} format="DD-MMM-YYYY, hh:mm A" />
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>
            </div>

           <div className=" flex items-cente mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.status || "-"}
                            </div>
                          </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
              <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Type
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.type}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Project Name
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.projectName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Contractor
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.mainContractorName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Consultant
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.consultantName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Supplier
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.supplierName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Installer
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.installerName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Conductors
                  </p>
                  <div className="w-[65%] py-2 text-xs font-medium text-[#606279] flex flex-wrap">
  <span className="mr-1">:</span>
  {data?.conductors?.map((conductors, idx) => (
    <span key={idx} className="text-xs font-medium  text-[#606279] mr-1">
      {conductors.assigneeName}
      {idx < data.conductors.length - 1 && ','}
    </span>
  ))}
</div> 

                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Location
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.location}
                  </p>
                </div>
           
               
              
              </div>
            
            </div>

            <div className="sm:flex gap-4 mt-4">
              <div className="sm:w-[50%] ">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                                  
                                  <div className="w-full flex gap-2 flex-wrap ">
                                    {data?.attachments &&
                                      filePathList.map((imgs, idx) => {
                                        console.log("img", imgs);
                                        return (
                                          <FilesView fileView={imgs} key={idx} />
                                        );
                                      })}
                                  </div>
                                </div>
              </div>
              
            </div>



          </div>
        </div>
        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
    {GetAccess("approvals") && isSubmit &&(
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} refSetData={setData} data={data} type={"tc-schedules"} preUrlName={"tc-schedules"}/>
 )}
                        {GetAccess("client_details") &&(
            
          <div className="w-full grid  border border-gary mt-4  rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Client Detail</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.clientName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Reference
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.clientRefNumber}
                </p>
              </div>
            </div>
                        )}

            <div className="w-full grid  border border-gary mt-4  rounded-lg ">
              <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                Report{" "}
              </p>
              <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                <div
                 onClick={handlePdfIconClick}   className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                >
                  <svg
                    width="20"
                    height="20"
                    className="fill-current text-baseColor-primary"

                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                  </svg>
                  <p className="w-auto text-[10px]">
                    {data?.ref || "Shedule form"}
                  </p>
                </div>
              </div>
            </div>
            {/* {GetAccess("comments") &&(

            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.pId}
                addurl={"/pr-comments/new-coment"}
                // geturl={`/pr-comments/by-PR/${data?.prd}`}
              />
            </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
      {showPdfComponent && (
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
        <button
                  className="absolute top-2 right-2 text-white bg-red-600"
                  onClick={() => setShowPdfComponent(false)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <PDFViewer pdfFile={viewPDF}/>
          
         
         
        </div>
      </div>
    )}
    </ScheduleLayout>
  );
}   

export default ViewSheduleTesting;
